<script setup lang="ts">
import type { LoyaltyReward } from '@/types/types'
import LoyaltyPreview from './LoyaltyPreview.vue'

defineProps<{
  rewards: LoyaltyReward[]
  preview?: boolean
}>()

const isLoaded = ref(false)

const handleLoadingState = () => {
  isLoaded.value = true
}
</script>
<template>
  <div v-show="isLoaded">
    <LoyaltyPreview :rewards="rewards" @end-loading="handleLoadingState"></LoyaltyPreview>
  </div>
  <div v-if="!isLoaded">
    <AppSkeleton type="default" />
  </div>
</template>
